/* Lupin Gold cart upsells (Enkindle 15/10/2026).
   Markup: snippets/cart-upsell.liquid. Loaded by sections/mini-cart.liquid and
   sections/lg-cart-upsell.liquid. Delegated on document because the drawer is
   re-rendered by innerHTML, so nothing inside it can hold its own listeners.

   - Choosing a design in a chooser row swaps the image, title, price and size list.
   - "Add" posts to /cart/add.js, then:
       in the drawer: re-renders it via Focal's cart:refresh (drawer stays open);
       on /cart:      fires lg-upsell:added, which lg-cart-upsell re-renders from.
   - 26/10/2026: every add carries the hidden line property _lg_src (data-lg-src on the
     button or row, e.g. cart-upsell-towel) so orders show which upsell sold.
     Protein tier buttons ([data-lg-tier-add]) add the packs needed to reach that tier.
   - 26/10/2026 go-live (Harvie): tier step-ups RAISE THE QUANTITY of the pack's existing
     line (untagged first) via /cart/change.js and carry no _lg_src, so the cart stays one
     line per pack size. No line of that pack yet = a plain add with no property. */
;(function () {
  if (window.lgUpsellReady) { return; }
  window.lgUpsellReady = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function rowOf(el) { return el.closest('.lg-upsell__row'); }

  function activeVariantId(row, btn) {
    var choice = row.querySelector('.lg-upsell__choice-input:checked');
    var pid = choice ? choice.value : null;
    var field = null;
    if (pid) {
      field = row.querySelector('.lg-upsell__size[data-for="' + pid + '"], .lg-upsell__single[data-for="' + pid + '"]');
    } else {
      field = row.querySelector('.lg-upsell__size:not([disabled]), .lg-upsell__single:not([disabled])');
    }
    var id = parseInt(field ? field.value : btn.getAttribute('data-variant-id'), 10);
    return isNaN(id) ? null : id;
  }

  function showError(btn, message) {
    var box = btn.closest('.lg-upsell');
    var err = box && box.querySelector('[data-lg-upsell-error]');
    if (!err) { return; }
    err.textContent = message || 'Sorry, that could not be added. Please try again.';
    err.hidden = false;
  }

  document.addEventListener('change', function (event) {
    var input = event.target.closest && event.target.closest('.lg-upsell__choice-input');
    if (!input) { return; }
    var row = rowOf(input);
    if (!row) { return; }
    var pid = input.value;

    var img = row.querySelector('[data-lg-upsell-img]');
    if (img && input.getAttribute('data-img')) {
      img.removeAttribute('srcset');
      img.src = input.getAttribute('data-img');
    }
    row.querySelectorAll('[data-lg-upsell-link]').forEach(function (a) { a.href = input.getAttribute('data-url'); });
    var title = row.querySelector('[data-lg-upsell-title]');
    if (title) { title.textContent = input.getAttribute('data-title'); }
    var now = row.querySelector('[data-lg-upsell-now]');
    if (now) { now.textContent = input.getAttribute('data-now'); }
    var was = row.querySelector('[data-lg-upsell-was]');
    if (was) { was.textContent = input.getAttribute('data-was'); }

    row.querySelectorAll('.lg-upsell__size, .lg-upsell__single').forEach(function (f) {
      var on = f.getAttribute('data-for') === pid;
      f.disabled = !on;
      if (f.tagName === 'SELECT') { f.hidden = !on; }
    });
    var btn = row.querySelector('.lg-upsell__add');
    if (btn) { btn.setAttribute('aria-label', 'Add ' + input.getAttribute('data-title')); }
  });

  function srcOf(el) {
    var tagged = el.closest('[data-lg-src]');
    return tagged ? tagged.getAttribute('data-lg-src') : 'cart-upsell';
  }

  // Protein tiers: tap a bigger tier, add the packs that reach it.
  document.addEventListener('click', function (event) {
    var tier = event.target.closest && event.target.closest('[data-lg-tier-add]');
    if (!tier || tier.disabled) { return; }
    var block = tier.closest('[data-lg-tiers]');
    if (!block) { return; }
    event.preventDefault();
    var n = parseInt(tier.getAttribute('data-lg-tier-add'), 10);
    var id = parseInt(block.getAttribute('data-variant-id'), 10);
    if (!(n > 0) || isNaN(id)) { return; }
    var state = tier.querySelector('.lg-tiers__state');
    block.querySelectorAll('[data-lg-tier-add]').forEach(function (b) { b.disabled = true; });
    addPacks(tier, state, id, n, function () {
      block.querySelectorAll('[data-lg-tier-add]').forEach(function (b) { b.disabled = false; });
    });
  });

  function hasProps(line) {
    var p = line.properties;
    return !!(p && Object.keys(p).some(function (k) { return p[k] !== null && p[k] !== ''; }));
  }

  // Raise the existing line of this pack by n (one clean line per pack size); add plain if none.
  function addPacks(btn, labelEl, variantId, n, onFail) {
    run(btn, labelEl, onFail, function (sections) {
      return fetch(root + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var lines = (cart.items || []).filter(function (l) { return l.variant_id === variantId && !l.selling_plan_allocation; });
          var line = lines.filter(function (l) { return !hasProps(l); })[0] || lines[0];
          if (line) {
            return post('cart/change.js', { id: line.key, quantity: line.quantity + n, sections: sections });
          }
          return post('cart/add.js', { items: [{ id: variantId, quantity: n }], sections: sections });
        });
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('.lg-upsell__add');
    if (!btn || btn.disabled) { return; }
    var row = rowOf(btn);
    if (!row) { return; }
    event.preventDefault();
    var variantId = activeVariantId(row, btn);
    if (!variantId) { return; }
    btn.disabled = true;
    addItems(btn, btn, [{ id: variantId, quantity: 1, properties: { _lg_src: srcOf(btn) } }], function () {
      btn.disabled = false;
    });
  });

  function post(path, body) {
    return fetch(root + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (json) {
        if (!r.ok) { throw json; }
        return json;
      });
    });
  }

  function addItems(btn, labelEl, items, onFail) {
    run(btn, labelEl, onFail, function (sections) {
      return post('cart/add.js', { items: items, sections: sections });
    });
  }

  // labelEl shows Adding / Added; onFail re-enables the controls.
  // request(sections) does the cart write and resolves with its JSON (carrying .sections in the drawer).
  function run(btn, labelEl, onFail, request) {
    var label = labelEl ? labelEl.textContent : '';
    if (labelEl) { labelEl.textContent = 'Adding'; }
    var box = btn.closest('.lg-upsell');
    var err = box && box.querySelector('[data-lg-upsell-error]');
    if (err) { err.hidden = true; }
    var onCartPage = !!btn.closest('[data-lg-cart-upsell]');

    request(onCartPage ? undefined : ['mini-cart'])
      .then(function (added) {
        if (labelEl) { labelEl.textContent = 'Added'; }
        btn.classList.add('is-added');
        return fetch(root + 'cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
            if (onCartPage) {
              document.dispatchEvent(new CustomEvent('lg-upsell:added', { detail: { cart: cart } }));
              return;
            }
            if (added && added.sections) { cart.sections = added.sections; }
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { cart: cart, openMiniCart: true, replacementDelay: 350 }
            }));
          });
      })
      .catch(function (e) {
        if (onFail) { onFail(); }
        if (labelEl) { labelEl.textContent = label; }
        btn.classList.remove('is-added');
        showError(btn, e && (e.description || e.message));
      });
  }
})();
